import TourButton from './TourButton.jsx'
import NotificationBell from './NotificationBell.jsx'

/**
 * Top navigation bar — mirrors q2-goals.html line 313-318.
 * Sticky at the top; cross-links to the Q2 Pipeline & Targets dashboard.
 * Includes the notification bell and the Tour launcher on the right.
 */
export default function TopNav() {
  return (
    <nav className="top-nav">
      <span className="brand">Common Trust</span>
      <span className="sep">·</span>
      <a
        href="https://dashboards.common-trust.com/hubspot-dashboard.html"
        target="_self"
      >
        📊 Q2 Pipeline &amp; Targets
      </a>
      <a href="#" className="active">🎯 Q2 Goals</a>
      <span
        style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8 }}
        data-notif-bell
      >
        <NotificationBell />
        <TourButton />
      </span>
    </nav>
  )
}
